import { render } from "./AddMouvementPage.vue?vue&type=template&id=f3b7f216&ts=true"
import script from "./AddMouvementPage.vue?vue&type=script&lang=ts"
export * from "./AddMouvementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__